<template>
  <el-dialog :visible.sync="visible" width="700px" title="观看人数" @close="handleClose" append-to-body :close-on-click-modal="false">
    <div v-if="viewers.length">
      <div v-for="(viewer, idx) in viewers" :key="idx" class="viewer-item">
        <el-avatar :src="viewer.avatar" size="large" />
        <span class="viewer-info">
          {{ viewer.name }}（{{ viewer.class }}） {{ viewer.phone }}
        </span>
        <el-button
          size="mini"
          :type="viewer.muted ? 'info' : 'primary'"
          :disabled="viewer.muted"
          @click="toggleMute(idx)"
        >
          {{ viewer.muted ? '解除禁言' : '禁言' }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ViewersDialog',
  data() {
    return {
      visible: false,
      viewers: []
    }
  },
  methods: {
    // 外部调用此方法弹出弹窗
    handleShow(viewerList = []) {
      // 这里可以传递观众列表，或自行请求接口
      this.viewers = viewerList.length
        ? viewerList
        : [
          {
            avatar: 'https://img.yzcdn.cn/vant/cat.jpeg',
            name: '杜三',
            class: '体验班',
            phone: '145****1478',
            muted: false
          },
          {
            avatar: 'https://img.yzcdn.cn/vant/cat.jpeg',
            name: '杜三',
            class: '体验班',
            phone: '145****1478',
            muted: true
          },
          // ...可添加更多
        ]
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    toggleMute(idx) {
      this.viewers[idx].muted = !this.viewers[idx].muted
    }
  }
}
</script>

<style scoped>
.viewer-item {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.viewer-info {
  margin-left: 16px;
  font-size: 16px;
  color: #333;
  flex: 1;
}
.mute-btn {
  width: 80px;
}
.empty {
  text-align: center;
  color: #999;
  padding: 30px 0;
}
</style>